
export { HorizontalProductCardSkeleton } from "/codebuild/output/src187247037/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src187247037/src/packages/shared-components/src/components/ProductCard/index.ts"